export default "__VITE_ASSET__Df1RP08I__"